<mat-icon
  [style.fontSize.px]="size"
  [style.width.px]="size"
  [style.height.px]="size"
  [matTooltip]="tooltipText"
  [matTooltipPosition]="tooltipPosition"
>
  {{ input.value | parse: context | async }}
</mat-icon>
